export default [{
  path: '/search',
  name: 'search',
  component: resolve => require(['@/views/home/search.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/home/home.js